// import Ball from '@/app/game/elements/Ball'
import BoxContainer from '@/app/game/elements/BoxContainer';

export default class World extends PIXI.Container
{
    constructor( settings )
    {
        super();

        this.width = 500;
        this.height = 500;

        this.x = 0;
        this.y = 0;

        this.elems = [];

        // this.box = PIXI.Sprite.fromImage( '/static/img/game/box.jpg' );
        // this.addChild( this.box );

        this.boxContainer = new BoxContainer({ version2: settings.version2 });
        this.addChild( this.boxContainer );

        this.boxContainer.spawnBalls();
        this.boxContainer.spawnPresents();
        this.boxContainer.spawnOrnaments();
        this.boxContainer.spawnSnowballs();

        this.boxContainer.updateLayerOrder();
    }
}



// WEBPACK FOOTER //
// ./src/app/game/World.js